module.exports = __webpack_public_path__ + "img/logo jeux.9654f3dd.png";